import { Flex } from "@chakra-ui/react";
import ButtonComp from "components/Button";
import { CardDownload } from "components/CardDownload";
import FileUploadComp from "components/FileUploadComp";
import { Header } from "components/Header";
import { toaster } from "components/ui/toaster";
import { useEffect, useState } from "react";
import { api } from "services/api";
// import { FiDownload } from "react-icons/fi";

// const users = {
//   dealrid: 1,
// };

// const groups = {
//   groupid: 1,
//   groupname: "abc",
// };

// const groupmember = {
//   id: 1,
//   groupid: 1,
//   dealerid: 1,
// };

// const addGroup = (name, [dealerid]) => {
//   /*

//    groupid =  groups.push(name)
//    groupmembers.push(groupid, dealerid) //loop

//     */
// };

// const items = [
//   {
//     id: 1,
//     label: "AU_Understanding_Guarantee",
//     type: "pdf",
//   },
// ];

function Documents() {
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  const [selectedItem, setSelectedItem] = useState();
  // const [file, setFile] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);

  const onDelete = async () => {
    console.log("onDelete =", selectedItem);
    setIsLoading(true);
    const res = await api.deleteDocument({
      documentid: selectedItem?.data?.documentid,
      document_name: selectedItem?.data?.document_name,
    });
    setIsLoading(false);
    toaster.create({
      title: res?.response?.data?.message || res?.data?.message || res?.message,
      type: res?.status === 200 ? "success" : "error",
    });

    if (res?.status === 200) {
      getList();
    }
  };

  const onUpload = async (data) => {
    if (isLoading) {
      return;
    }
    const filenew = data;
    setIsLoading(true);
    const res = await api.uploadDocument({ file: filenew });
    setIsLoading(false);
    toaster.create({
      title: res?.response?.data?.message || res?.data?.message || res?.message,
      type: res?.status === 200 ? "success" : "error",
    });

    if (res?.status === 200) {
      getList();
    }
    // setFile();
  };

  // const onFileChange = (v) => {
  //   console.log("onFileChange", v);
  //   setFile(v);
  // };

  const onDownload = () => {
    setIsLoading(true);
    api
      .downloadDocument({
        document_name: selectedItem?.data?.document_name,
      })
      .then((res) => {
        setIsLoading(false);
        console.log("res", res);
        if (res?.status === 200) {
          try {
            if (res?.data?.file?.type === "pdf" && res?.data?.file?.stream) {
              // console.log(res?.data?.file?.stream || "");
              let pdf = {
                file: `data:application/pdf;base64,${res?.data?.file?.stream}`,
                file_name: res?.data?.file?.name || "AU_Warranties",
              };
              const pdfLink = `${pdf.file}`;
              const anchorElement = document.createElement("a");
              const fileName = `${pdf.file_name}`;
              anchorElement.href = pdfLink;
              anchorElement.download = fileName;
              anchorElement.click();
            }
          } catch (error) {
            console.log(error);
          }
          return;
        }
        toaster.create({
          title:
            res?.response?.data?.message || res?.data?.message || res?.message,
          type: "error",
        });
        return;
      });
  };

  const onSelectItm = (data) => {
    console.log("data", data.item);
    setSelectedItem(data?.item);
    if (list && list[0]?.id) {
      setList(
        list.map((a) => {
          a.selected = false;
          if (a?.id === data?.item?.id) {
            a.selected = true;
          }
          return a;
        })
      );
    }

    // setList(data?.list);
  };

  const getList = async () => {
    setSelectedItem();
    setIsLoading(true);
    const res = await api.getDocuments();
    setIsLoading(false);
    if (res?.status === 200) {
      if (res?.data && res?.data[0]) {
        setList(
          res.data.map((a) => ({
            id: a?.documentid,
            label: a?.document_name,
            type: "pdf",
            data: a,
          }))
        );
      } else {
        setList([]);
      }
      return;
    }
    toaster.create({
      title: res?.response?.data?.message || res?.data?.message || res?.message,
      type: "error",
    });

    if (res?.status === 200) {
      getList();
    }
  };

  useEffect(() => {
    getList();
    let loginRes = window.localStorage.getItem("loginRes");
    loginRes = loginRes ? JSON.parse(loginRes) : {};

    if (loginRes?.userid === 22) {
      setIsAdmin(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header label={"Documents"} isLoading={isLoading} />
      <Flex
        flexFlow={"wrap"}
        gap={"1rem"}
        alignItems={"center"}
        justify={"end"}
      >
        <ButtonComp
          label="Download"
          keyname="download-ic"
          disabled={!selectedItem || isLoading}
          onClick={onDownload}
        />
        {/* <IconButton variant={'plain'}>
          <FiDownload />
        </IconButton> */}

        {isAdmin ? (
          <>
            <ButtonComp
              disabled={!selectedItem || isLoading}
              onClick={onDelete}
              keyname="delete-ic"
            />
            <FileUploadComp
              variant="button"
              // onChange={onFileChange}
              // filename={file?.name}
              onUpload={onUpload}
              accept={".pdf"}
            />
          </>
        ) : null}

        {/* <Flex alignItems={"center"}>
          <Input
            type="file"
            onChange={(e) => onFileChange(e.target.files[0])}
          />
          <Button colorScheme="blue" onClick={onUpload}>
            Upload
          </Button>
        </Flex> */}
      </Flex>
      <Flex
        flex={1}
        // m={"2rem"}
        pt={"1rem"}
        mt={"1rem"}
        // gap={"1rem"}
        // wrap={"wrap"}
        overflowY={"auto"}
        overflowX={"hidden"}
        // direction={"column"}
        // justify={'flex-start'}
      >
        <Flex
          alignSelf={"start"}
          flex={1}
          // m={"2rem"}
          // pt={"2rem"}
          // mt={"1rem"}
          gap={"1rem"}
          wrap={"wrap"}
          overflowY={"auto"}
          overflowX={"hidden"}
        >
          {list?.map((item, index) => (
            <Flex
              // w={"100%"}
              w={"25rem"}
              // variant={"plain"}
              onClick={(e) => onSelectItm({ item, index })}
              alignSelf={"start"}
              overflow={"hidden"}
              // bg={'red'}
            >
              {/* onSelect={onSelectItm} */}
              {/* selectedItem={selectedItem} */}
              <CardDownload {...item} />
            </Flex>
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
}

export default Documents;
